import { ObjectWithAnyValues } from "utils/types";
import { BaseModel } from "../BaseModel";
import { TermTypeFields, TermTypeProps } from "./types";

export class TermType extends BaseModel {
	[TermTypeFields.CREATED_AT]: string;
	[TermTypeFields.DESCRIPTION]: string;
	[TermTypeFields.ID]: string;
	[TermTypeFields.NAME]: string;
	[TermTypeFields.UPDATED_AT]: string;
	[TermTypeFields.UPDATED_BY]: string;
	[TermTypeFields.STATUS]: string;

	constructor(data: TermTypeProps) {
		super(data);

		this[TermTypeFields.CREATED_AT] = data[TermTypeFields.CREATED_AT];
		this[TermTypeFields.DESCRIPTION] = data[TermTypeFields.DESCRIPTION];
		this[TermTypeFields.ID] = data[TermTypeFields.ID];
		this[TermTypeFields.NAME] = data[TermTypeFields.NAME];
		this[TermTypeFields.UPDATED_AT] = data[TermTypeFields.UPDATED_AT];
		this[TermTypeFields.UPDATED_BY] = data[TermTypeFields.UPDATED_BY];
		this[TermTypeFields.STATUS] = data[TermTypeFields.STATUS];
	}

	static override createFromResponse(response: ObjectWithAnyValues) {
		if (!response) {
			return response;
		}

		const termType = new TermType({
			[TermTypeFields.CREATED_AT]: response.createdAt,
			[TermTypeFields.DESCRIPTION]: response.description,
			[TermTypeFields.ID]: response.id,
			[TermTypeFields.NAME]: response.name,
			[TermTypeFields.UPDATED_AT]: response.updatedAt,
			[TermTypeFields.UPDATED_BY]: response.updatedBy,
			[TermTypeFields.STATUS]: response.status
		});
		return termType;
	}
}
